export default {
  DEFAULT_PRICE_SETTINGS: {
    id: null,
    itineraryPriceIntervalId: null,
    description: '',
    date: null,
    hotels: null,
    excursions: [],
    extras: [],
    transportAllotments: [],
    carRental: [],
  },
  DEFAULT_HOTEL: {
    priceSettingId: null,
    dayProgramId: null,
    included: false,
    singleRoomSupplementPrice: null,
    category: 'A',
    accommodationSiteId: null,
    site: null,
    accommodation: null,
    setting: null,
  },
  DEFAULT_SETTING: {
    id: null,
    supplier: null,
    prices: [],
    commissionRatio: null,
    contributionRatio: null,
    supplierGrossPrice: null,
    pricePerPerson: null,
    pricePerPersonExchanged: null,
    currency: {
      min: null,
      max: null,
    },
    discounts: [],
  },
  DEFAULT_EXTRA: {
    priceSettingId: null,
    dayProgramId: null,
    extraId: null,
    name: null,
    included: null,
    category: null,
    setting: null,
  },
  DEFAULT_PAX_PRICE: {
    priceSettingId: null,
    price: null,
    paxFrom: null,
    paxTo: null,
    priceKey: null,
  },
  DEFAULT_PACKAGE_PRICE: {
    priceSettingId: null,
    singleRoomSupplementPrice: null,
    category: null,
    setting: null,
  },
  DEFAULT_DISCOUNT_PRICE: {
    priceSettingId: null,
    ageFrom: null,
    ageTo: null,
    discount: null,
    discountKey: null,
  },
  DEFAULT_GROSS_PRICE: {
    index: null,
    currency: null,
    price: null,
    calculatedPrice: null,
    ages: [],
  },
  DEFAULT_ITINERARY_PRICE: {
    id: null,
    itineraryId: null,
    minimumAge: null,
    itineraryPriceIntervals: [],
  },
  DEFAULT_PRICE_INTERVAL: {
    id: null,
    startDate: null,
    bookFrom: null,
    bookTo: null,
    arrivalFrom: null,
    arrivalTo: null,
    maxAllotments: 0,
    active: false,
    grossPrice: null,
    guaranteed: false,
    bookingFlow: false,
    fixedExchangeRate: false,
    transportAllotments: [],
    intervalDays: [],
  },
};



// WEBPACK FOOTER //
// ./src/variables/itineraryPrices/itineraryPricesDefaultObjects.js